module.exports = __webpack_public_path__ + "static/media/icon-face.570085b0.svg";